import React, { FC, useCallback, useContext, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { data, dataByUser } from './TradeHistoryTableLists'
import { TableSmall } from '../../../../../../components/Dashboard/TableSmall'
import { AppStateContext, useRest } from '../../../../../../components/Context'
import { routes } from '../../../../../../constants/routes'
import { userPermissionEnum } from '../../../../../../constants/userPermissions'
import { TableComponent } from '../../../../../../components/Dashboard/Table'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 4, 4, 4),
    background: theme.palette.background.paper,
  },
}))

interface TradeHistorySectionProps {
  title?: string
  userIdSf?: string
}

export const TradeHistory: FC<TradeHistorySectionProps> = ({ title, userIdSf }) => {
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})
  const { getUserRole } = useContext(AppStateContext)
  const [userRole, setUserRole] = useState<string>()

  useEffect(() => setUserRole(getUserRole()), [setUserRole, getUserRole])

  const loadData = useCallback(
    async (page) => {
      let cleanupFunction = false
      setLoading(true)

      // eslint-disable-next-line no-nested-ternary
      const url = userIdSf
        ? `${data.request}/${userIdSf}?page=${page}&count=5`
        : userRole === userPermissionEnum.sole_trader
        ? `${dataByUser.request}?page=${page}&count=10`
        : `${data.request}?page=${page}&count=5`

      rxiosAuth.get(url).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          setValues(next)
          if (!cleanupFunction) setLoading(false)
        },
        (error: Error) => {
          toast.error(error.message)
          setLoading(false)
        },
        () => {
          setLoading(false)
        },
      )
      cleanupFunction = true
    },
    [rxiosAuth, userIdSf, userRole],
  )

  useEffect(() => {
    ;(async () => {
      await loadData('1')
    })()
    // eslint-disable-next-line
  }, [])

  return (
    <Grid item xs={12} className={classes.formWrap}>
      <FormProvider {...formMethods}>
        <Grid item xs={12} className={classes.container}>
          {title ? <Typography variant={'h6'}>{title}</Typography> : ' '}
        </Grid>

        <Grid item xs={12} className={classes.sectionWrap}>
          {userRole === userPermissionEnum.sole_trader ? (
            <TableComponent
              columns={dataByUser.columns}
              data={values.items}
              params={values.meta}
              // eslint-disable-next-line
              loadData={(pageNumber: string | number) => loadData(pageNumber)}
              loading={loading}
            />
          ) : (
            <TableSmall
              columns={data.columns}
              data={values.items}
              params={values.meta}
              // eslint-disable-next-line
              loadData={(pageNumber: any) => loadData(pageNumber)}
              viewAll
              viewAllLink={userIdSf ? routes.VIEW_ALL_TRADES_BY_ID.replace(':id', userIdSf) : routes.VIEW_ALL_TRADES}
              loading={loading}
            />
          )}
        </Grid>
      </FormProvider>
    </Grid>
  )
}
